export const TYPING_LONG_TASK_EVENTS_BEFORE_ONE_MINUTE = 'typing-long-task-events-before-one-minute';
export const TYPING_LONG_TASK_EVENTS_AFTER_ONE_MINUTE = 'typing-long-task-events-after-one-minute';
export const TYPING_LONG_TASK_EVENTS = 'typing-long-task-events';
export const RICH_TEXT_EDITOR_TOTAL_RENDERS = 'rich-text-editor-total-renders';
export const RICH_TEXT_EDITOR_REACTION_TIME = 'prosemirror-reaction-time';
export const SEND_BUTTON_ENABLED_THREAD_SWITCH = 'send-button-enabled-thread-switch';
export const SEND_BUTTON_ENABLED_FIRST_LOAD = 'send-button-enabled-first-load';